import React, { useEffect } from 'react';
import DegreeApprenticeshipLandingPage from '../../features/specialty/degreeapprenticeship';

export default function DegreeApprenticeshipLandingRoute() {
  useEffect(() => {
    document.title = "IVORI — Degree Apprenticeship Assessment Centre Prep";
    window.scrollTo(0, 0);
  }, []);

  return <DegreeApprenticeshipLandingPage />;
}
